import { SliderDots } from '@studiometa/ui';

/**
 * Slider component
 */
export default class GalleryDots extends SliderDots {
  /**
   * Padding size
   */
  paddingSize = 8;

  currentPosition = 0;

  /**
   * Breakpoints
   */
  breakpoints = ['xxs', 'xs', 's'];

  /**
   * Component configuration
   */
  static config = {
    name: 'GalleryDots',
    refs: ['wrapper', 'prev', 'next', ...SliderDots.config.refs],
  };


  mounted() {
    this.thumbHeight = this.$refs.dots[0].offsetHeight + this.paddingSize;
    this.sliderItems = document.querySelectorAll('[data-component="SliderItem"]');
    this.offsetHeader = document.querySelector('.shopify-section--header').offsetHeight;
    this.wrapperHeight = this.$refs.wrapper.parentElement.offsetHeight;
    this.visibleThumbs = Math.ceil(this.wrapperHeight / this.thumbHeight);
    this.sliderItemsArray = Array.from(this.sliderItems);

    if (!this.isMobile) {
      const observer = new IntersectionObserver(this.checkIntersection.bind(this), {
        threshold: 0.5,
      });
  
      this.sliderItems.forEach((target) => {
        observer.observe(target);
      });
    }


    super.mounted();
  }

   /**
   * Check gallery intersection
   * @param  {object} entries
   * @returns {void}
   */
  checkIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const position = this.sliderItemsArray.findIndex(
          (instance) => instance === entry.target
        );
        
        this.currentPosition = position;
        this.update(this.currentPosition);

        const minVisible = this.visibleThumbs;
        const offset = this.currentPosition < minVisible ? 0 : (this.currentPosition - minVisible + 1) * this.thumbHeight;
        this.$refs.wrapper.style.transform = `translateY(-${offset}px)`;
      }
    });
  }

  /**
   * Handle dot click event
   */
  onDotsClick({ index }) {
    if (this.isMobile) {
      this.$parent.goTo(index);
      return;
    }

    const scrollTarget = this.$parent.$children.SliderItem[index].$el;

    window.scrollTo({
      top: scrollTarget.offsetTop + (index == 0 ? 0 : this.offsetHeader),
      behavior: 'smooth',
    });
  }

  /**
   *
   */
  onNextClick() {
    if ((this.$refs.dots.length - this.visibleThumbs) === this.currentPosition) {
      return;
    }

    this.currentPosition += 1;
    this.$refs.wrapper.style.transform = `translateY(-${this.currentPosition * this.thumbHeight}px)`;
  }

  /**
   *
   */
  onPrevClick() {
    if (this.currentPosition === 0) {
      return;
    }

    this.currentPosition -= 1;

    this.$refs.wrapper.style.transform = `translateY(-${this.currentPosition * this.thumbHeight}px)`;
  }

  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }
}
